var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_6744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98955 10.983C8.74628 10.983 10.981 8.74823 10.981 5.9915C10.981 3.23477 8.74628 1 5.98955 1C3.23282 1 0.998047 3.23477 0.998047 5.9915C0.998047 8.74823 3.23282 10.983 5.98955 10.983Z",
    stroke: "#8200DB",
    strokeWidth: 0.9983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99414 5.9915C3.99414 4.13303 4.70904 2.34579 5.99074 1C7.27244 2.34579 7.98734 4.13303 7.98734 5.9915C7.98734 7.84996 7.27244 9.63721 5.99074 10.983C4.70904 9.63721 3.99414 7.84996 3.99414 5.9915Z",
    stroke: "#8200DB",
    strokeWidth: 0.9983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 5.98828H10.981",
    stroke: "#8200DB",
    strokeWidth: 0.9983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_6744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9796,
    height: 11.9796,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.2e19d9386a41cd69d307ad0066b53745.svg";
export { ForwardRef as ReactComponent };